import { createEvent } from 'effector'

const connectSteamEvent = createEvent()
const openSteamModalEvent = createEvent()

export const connectFarcanaEvent = createEvent()

export { connectSteamEvent, openSteamModalEvent }
